import '@fortawesome/fontawesome-free/js/all.min.js';
import React, { Component } from 'react';
import Loadable from 'react-loadable';
import { Provider } from 'react-redux';
import { getStore } from '../utils';
import { AppContextProvider } from './context';
import loading from './Loader';


const DefaultLayout = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "DefaultLayout" */ './DefaultLayout'
        ),
    loading
});

const store = getStore();

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <AppContextProvider>
                    <DefaultLayout/>
                </AppContextProvider>
            </Provider>

        );
    }
}

export default App;
